import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";

import {
  RESIDUAL_VALUE_BASIC_STEP,
  RESIDUAL_VALUE_DETAILS_STEP,
  RESIDUAL_VALUE_EQUIPMENT_STEP,
  RESIDUAL_VALUE_INTRO_TEXTS,
} from "./consts";
import ResidualValueBasicScene from "./scenes/ResidualValueBasicScene";
import ResidualValueDetailsScene from "./scenes/ResidualValueDetailsScene";
import ResidualValueEquipmentScene from "./scenes/ResidualValueEquipmentScene";
import { ResidualValueIntroProps, ResidualValueSceneProps } from "./types";

/** Scena za korak izračuna ostatka vrijednosti. */
const STEP_SCENES: Record<number, React.FC<ResidualValueSceneProps>> = {
  [RESIDUAL_VALUE_BASIC_STEP]: ResidualValueBasicScene,
  [RESIDUAL_VALUE_DETAILS_STEP]: ResidualValueDetailsScene,
  [RESIDUAL_VALUE_EQUIPMENT_STEP]: ResidualValueEquipmentScene,
};

/**
 * Lijevi panel izračuna ostatka vrijednosti: za korak vlastita scena s karticama koje prikazuju
 * upisane podatke, a ispod objašnjenje koraka.
 */
const ResidualValueIntro: React.FC<ResidualValueIntroProps> = ({ stepCurrent, stepCount, ...sceneProps }) => {
  const stepKey = STEP_SCENES[stepCurrent] ? stepCurrent : RESIDUAL_VALUE_BASIC_STEP;
  const Scene = STEP_SCENES[stepKey];
  const text = RESIDUAL_VALUE_INTRO_TEXTS[stepKey];

  return (
    <ShowcaseIntro
      sceneKey={stepKey}
      title={text.title}
      description={text.description}
      stepCurrent={stepKey}
      stepCount={stepCount}
    >
      <Scene {...sceneProps} />
    </ShowcaseIntro>
  );
};

export default memo(ResidualValueIntro);
